import { Verified } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

const DescriptionContent = () => {
  return (
    <Box p={3}>
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", my: 1 }}>
          <Typography>By</Typography>
          <Typography mx={1} fontWeight={"bold"}>
            Remilia
          </Typography>
          <Verified fontSize='inherit' sx={{ color: "#2282E2" }} />
        </Box>
        <Typography>
          Milady Maker is a collection of 10,000 generative pfpNFT's in a
          neochibi aesthetic inspired by Tokyo street style tribes.
        </Typography>
      </Box>
    </Box>
  );
};

export default DescriptionContent;
